module.exports = __webpack_public_path__ + "img/ps-30b.164f6346.jpg";